// extracted by mini-css-extract-plugin
module.exports = {"searchTitle":"ProductListing_searchTitle___WPDb","categoryName":"ProductListing_categoryName__QsI1r","bannerImage":"ProductListing_bannerImage__wED6y"};